import { render, staticRenderFns } from "./UserTab1.vue?vue&type=template&id=11d9f65c&scoped=true"
import script from "./UserTab1.vue?vue&type=script&lang=js"
export * from "./UserTab1.vue?vue&type=script&lang=js"
import style0 from "./UserTab1.vue?vue&type=style&index=0&id=11d9f65c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d9f65c",
  null
  
)

export default component.exports